<template>
  <v-dialog
    v-model="showDialog"
    width="500"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Confirmation de participation reçue
      </v-card-title>

      <v-card-text>
        <div v-if="data">
          Confirmez que vous avez reçu la participation de <br/>
          <b>{{totalStudent.toFixed(2)}}€ + {{totalAdhesion.toFixed(2)}}€ = {{ total.toFixed(2) }}€</b> <br/>
          de la part de <b>{{ data.participant.fullName }}</b> pour l'édition {{ edition }} ?
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="showDialog = false"
        >
          Fermer
        </v-btn>
        <v-spacer />
        <v-btn
          outlined
          color="warning"
          :loading="isSaving"
          @click="update(false)"
        >
          N'a pas été reçu
        </v-btn>
        <v-btn
          outlined
          color="success"
          :loading="isSaving"
          @click="update(true)"
        >
          A été recu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    props: {
      value: Boolean,
      data: Object,
    },
    data: () => ({
      isSaving: false,
    }),
    computed: {
      edition: get('artifex/config.edition.edition'),
      totalStudent () {
        return this.data ? this.data.classes
          .map(one => one.nbStudents * this.$store.state.artifex.config.edition.participationParEleve)
          .reduce((val, acc) => val + acc) : -1
      },
      totalAdhesion () {
        return this.$store.state.artifex.config.edition.participationAdhesion 
      },
      total () {
        return this.totalStudent + this.$store.state.artifex.config.edition.participationAdhesion
      },
      showDialog: {
        get () { return this.value },
        set (val) {
          this.$emit('input', val)
        },
      },
    },
    methods: {
      update (hasPaid) {
        const userId = this.data.user.id
        this.isSaving = true
        this.$lco.admin
          .updateParticipantHasPaid({ hasPaid, userId })
          .then(() => {
            this.data.hasPaid = hasPaid
            this.isSaving = false
            this.showDialog = false
          })
          .catch(err => {
            console.log(err)
            this.isSaving = false
          })
      },
    },
  }
</script>
